import Vue from 'vue'
import Router from 'vue-router'
import bossIndex from './../views/bossIndex.vue'
import kmContainer from './../components/km-container/index.vue'
import MonitorCheck from './../views/Monitor/Health/Check/slbtest.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/bossIndex',
      name: 'bossIndex',
      component: kmContainer
    },
    {
      path: '/bossIndex',
      name: 'bossIndex',
      component: bossIndex
    },
    {
      path: '/monitor/health/check',
      component: MonitorCheck,
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js